import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../../Css/balance.css'
import { useAuth } from "../../Middleware/context/AuthContext";


function Balance({ total, setLocation }) {
  const navigate = useNavigate();
  const [coords, setCoords] = useState(null);
  const {user}=useAuth();


//------------------------------



function verUser (user){


  if(!user){

    navigate("/UserErro")
  }

  else if(user) navigate('/checkout')

}





///----------------------------



  useEffect(() => {
    if (!navigator.geolocation) return;

    navigator.geolocation.getCurrentPosition(
      (position) => {
        const data = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        };
        setCoords(data);
        setLocation(data);
      },
      (err) => console.error(err)
    );
  }, [setLocation]);

  return (
    <div className="balance-banner">
      <div className="balance-info">
        <h3>Total da Compra</h3>
        <h2>Kz {total.toLocaleString()}</h2>

        {coords && (
          <small>
            Localização: {coords.lat.toFixed(4)} , {coords.lng.toFixed(4)}
          </small>
        )}
      </div>

      <button className="checkout-btn" onClick={() =>{verUser(user)}}>
        Finalizar Compra
      </button>
    </div>
  );
}

export default Balance;
